<template>
	<form ref="submitPaymentForm" method="POST" charset="UTF-8" :action="formUri">
		<input v-for="input in inputs" :key="input.name" type="hidden" :name="input.name" :value="input.value" />
	</form>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { initNetaxept } from '@/api/modules/confirm'

export default {
	data() {
		return {
			transactionId: null,
			paymentId: null,
		}
	},
	computed: {
		netaxeptlang() {
			switch (this.$i18n.locale) {
				case 'en':
					return 'English'
				case 'de':
					return 'German'
				default:
					return 'Danish'
			}
		},
		redirecturl() {
			return window.location.origin + '/payment/' + `?provider=Netaxept&reference=${encodeURIComponent(this.orderId)}`
		},
		formUri() {
			if (process.env.VUE_APP_SERVER === 'live') {
				return 'https://epayment.nets.eu/Terminal/default.aspx'
			} else {
				return 'https://test.epayment.nets.eu/Terminal/default.aspx'
			}
		},
		inputs() {
			const inputs = [
				{
					name: 'merchantId',
					value: this.merchantId,
				},
				{
					name: 'transactionId',
					value: this.transactionId,
				},
			]
			return inputs
		},
		...mapGetters({
			orderId: 'order/getOrderId',
			merchantId: 'system/getNetaxeptMerchantId',
		}),
	},
	watch: {
		transactionId: function (value) {
			if (value) {
				Vue.nextTick().then(() => {
					// DOM updated
					this.$refs.submitPaymentForm.submit()
				})
			}
		},
	},
	mounted() {
		this.$emit('loading', 'Redirecting to Netaxept')
		return initNetaxept(this.orderId, this.redirecturl, this.netaxeptlang).then((response) => {
			if (!response.ok) {
				throw new Error(JSON.stringify(response))
			}

			this.paymentId = response.responseBody.paymentId
			this.transactionId = response.responseBody.netaxeptTransactionId
		})
	},
}
</script>
